import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72ff15a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Unread")
const _hoisted_2 = { class: "flex ion-align-items-start heading-top ion-justify-content-between" }
const _hoisted_3 = { class: "black heading-main heading-noti ion-no-margin" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "black noti-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderMain = _resolveComponent("HeaderMain")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_HeaderMain, {
        "page-title": "Notifications",
        "default-href": "/home",
        "icon-filter": false,
        "icon-notification": true,
        "mark-all-seen": _ctx.markAllSeen
      }, null, 8, ["mark-all-seen"]),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_ion_spinner, {
                key: 0,
                name: "bubbles",
                class: "flex ion-align-items-center ion-justify-content-center spinner ion-margin-top"
              }))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (noti) => {
            return (_openBlock(), _createBlock(_component_ion_card, {
              class: "noti-card ion-activatable ripple-parent",
              mode: "ios",
              key: noti.id
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_content, { class: "noti-card-top" }, {
                  default: _withCtx(() => [
                    (
              !_ctx.notificationStats ||
              !_ctx.notificationStats.event ||
              !_ctx.notificationStats.event.notification_ids ||
              !_ctx.notificationStats.event.notification_ids.includes(noti.id)
            )
                      ? (_openBlock(), _createBlock(_component_ion_badge, {
                          key: 0,
                          color: "danger"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_1
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("h2", _hoisted_3, _toDisplayString(noti.title), 1),
                      (noti.created_at)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.fireBaseTime(noti.created_at)), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("p", _hoisted_5, _toDisplayString(noti.body), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}